import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import { calcShelfTableProps } from '@aytm/app/stats/page/question-views/sh/lib/shelf-table-utils'

// components
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

// the shelf picture sizes its own frame, so the placeholder holds no height open
const PLACEHOLDER_HEIGHT = 0
import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import Controls from '@aytm/app/stats/page/question-views/sh/components/shelf/Controls'
import Chart from '@aytm/app/stats/page/question-views/sh/components/shelf/Chart'

// The shelf half of a shelf-test question: the shelf-view picker, the shelf rendering
// (image + heatmap/click overlays) and the "Shop Metrics" summary table. Collapsing hides
// the shelf and the table but keeps the controls so it can be reopened.
//
// The placeholder height is 0 because the shelf sizes itself from the loaded image; the
// old Backbone path passed the same 0 with required=true.
const ShelfBlock = ({
  id,
  questionKey,
  components,
  answer,
  viewMode,
  format,
  shelfData,
  shelfType,
  shelfViewMode,
  shelfCollapsed,
  chartMode,
  globalChartMode,
  preview,
  isAnimated,
  onModelChange,
  onShelfCollapsedChange,
  onShelfChartReady
}) => {
  const tableProps = calcShelfTableProps({ answer, viewMode, format, shelfPreviewData: shelfData })

  return (
    <>
      {isComponentOn(components, 'controls') && (
        <Controls
          viewMode={shelfViewMode}
          chartCollapsed={shelfCollapsed}
          onModelChange={onModelChange}
          onToggle={onShelfCollapsedChange}
        />
      )}
      {!shelfCollapsed && (
        <>
          {isComponentOn(components, 'chart') && !isNoneChartMode(chartMode, globalChartMode) && (
            <ChartPlaceholder
              height={PLACEHOLDER_HEIGHT}
              required
              isLoading={'loading' === answer}
              isAnimated={isAnimated}
            >
              <Chart
                id={id}
                questionKey={questionKey}
                shelfData={shelfData}
                shelfType={shelfType}
                shelfViewMode={shelfViewMode}
                shelfAnswer={answer}
                preview={preview}
                onChartReady={onShelfChartReady}
              />
            </ChartPlaceholder>
          )}
          {isComponentOn(components, 'table') && <Table id={id} {...tableProps} />}
        </>
      )}
    </>
  )
}

ShelfBlock.displayName = 'ShelfTestShelfBlock'

ShelfBlock.propTypes = {
  id: PropTypes.string,
  questionKey: PropTypes.string,
  components: PropTypes.object,
  answer: answerPropType,
  viewMode: PropTypes.string,
  format: PropTypes.object,
  shelfData: PropTypes.object,
  shelfType: PropTypes.string,
  shelfViewMode: PropTypes.string,
  shelfCollapsed: PropTypes.bool,
  chartMode: PropTypes.string,
  globalChartMode: PropTypes.string,
  preview: PropTypes.object,
  isAnimated: PropTypes.bool,
  onModelChange: PropTypes.func,
  onShelfCollapsedChange: PropTypes.func,
  onShelfChartReady: PropTypes.func
}

export default ShelfBlock
